module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/clipboard-81b6e50fd1633733823df5380c948f18.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/clipboard.svg
// module id = b0+l
// module chunks = 24